<template>
  <div>
    <Header />
    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i>ÇEK GÜNCELLEME EKRANI</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item">
            <a href="#">ÇEK GÜNCELLEME EKRANI</a>
          </li>
        </ul>
      </div>
      <div class="row form-margin">
        <div class="col-md-12 tex-center d-flex align-items-center flex-column">
          <div class="tile">
            <h3 class="tile-title">ÇEK GÜNCELLEME EKRANI</h3>

            <div class="tile-body">
              <form>
                <div class="form-group">
                  <label class="control-label">FİRMA ADI : </label>
                  <span
                    style="background-color: rgb(253, 109, 73);"
                    class="form-control"
                    >{{ veriler.firmaname }}</span
                  >
                </div>
                <div class="form-group">
                  <label class="control-label">ÇEK SERİ NO : </label>
                  <span
                    style="background-color: rgb(253, 109, 73);"
                    class="form-control"
                    >{{veriler.banka}}   {{ veriler.serino }}</span
                  >
                </div>
                <div class="form-group">
                  <label class="control-label">Tarih Güncelleme</label>
                  <input
                    v-model="veriler.vade"
                    class="form-control"
                    type="date"
                    placeholder="Delgi Çapı"
                    style="background-color: rgb(127, 238, 132);"
                  />
                </div>
                <div class="form-group">
                  <label class="control-label">DEVAMINA YAZILAN ÇEK BİLGİSİ :  </label>
                  <span
                    class="form-control"
                    type="text"
                    placeholder="AÇIKLAMA GİRİNİZ"
                    style="background-color: rgb(253, 109, 73);"
                    >{{ veriler.vade }} ~ {{ veriler.maincekname }} ~ {{ veriler.serino }}
                  </span>
                </div>
                <div class="form-group">
                  <label class="control-label"
                    >GÜNCELLEME SONRASI DEVAMINA YAZILACAK ÇEK</label
                  >
                  <select
                    style="background-color: rgb(127, 238, 132);"
                    class="form-control"
                    @change="changecheck($event)"
                  >
                    <option value="" selected disabled>DEVAMINA YAZILACAK ÇEKİ SEÇİNİZ</option>
                    <option
                      v-for="ceks in dropCeks"
                      :value="ceks.id"
                      :key="ceks.id"
                      >{{ ceks.vade }} ~ {{ ceks.firmaname }}  ~ {{ ceks.serino }}  ~ ÇEK TUTARI : {{ ceks.tutar }}₺ ~ KALAN TUTAR : {{ ceks.kalantutar }}₺</option
                    >
                  </select>
                </div>
                <div class="form-group">
                  <label class="control-label">Açıklama</label>
                  <input
                    v-model="veriler.content"
                    class="form-control"
                    type="text"
                    placeholder="AÇIKLAMA GİRİNİZ"
                    style="background-color: rgb(127, 238, 132);"
                  />
                </div>
                <div class="form-group">
                  <label class="control-label">ÇEK TUTARINI GİRİNİZ :</label>
                  <input
                    v-model="veriler.tutar"
                    class="form-control"
                    type="text"
                    placeholder="DETAY GİRİNİZ"
                    style="background-color: rgb(127, 238, 132);"
                  />
                </div>
              </form>
            </div>

            <div class="tile-footer">
              <button @click="sendData()" class="btn btn-success" type="button">
                <i class="fa fa-fw fa-lg fa-check-circle"></i>Güncelle
              </button>
              <button
                @click="deleteNote()"
                class="btn btn-danger fileupload-exists"
              >
                <i class="fa fa-trash-o"></i>Çeki Sil
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";

export default {
  data() {
    return {
      dropCeks: [],
      category: [],
      makinaId: "",
      tempmachine: "",
      temppersonel: "xx",
      personeller: [],
      sahaname: "",
      yonlendir: "",
      veriler: [],
      giderId: this.$route.query.id,
      sahaYonlendir: this.$route.query.sahaId,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    var token = localStorage.getItem("token");
    if (!token) {
      this.$router.push("/");
    }
    var url = store.state.base_url + "Cek/getByIdCheck.php?key=123";
    var datas = { 
        checkId: this.giderId,
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),

    };
    axios
      .post(url, JSON.stringify(datas))
      .then((response) => {
        this.veriler = response.data;
      })
      .catch((err) => {
        console.log(err.response);
      });
    var url = store.state.base_url + "Cek/getAllCekMainDrop.php?key=123";
    var datas = { 
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
    };
    axios
      .post(url, JSON.stringify(datas))
      .then((response) => {
        this.dropCeks = response.data.data;
      })
      .catch((err) => {
        console.log(err.response);
      });
  },
  methods: {
    changemakina(event) {
      this.makinaId = event.target.value;
    },
    changecheck(event) {
      this.temppersonel = event.target.value;
    },
    deleteNote: function() {
      var url = store.state.base_url + "Cek/deleteCheck.php?key=123";

      var datas = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        raporId: this.giderId,
      };
      axios
        .post(url, JSON.stringify(datas))
        .then((response) => {
          console.log(response.data);
          if (response.data == true) {
            this.$swal({
              text: "Rapor Başarıyla Silindi",
              icon: "success",
              closeOnClickOutside: false,
            });
          }
          //////////console.log(response);
        })
        .catch((error) => {
          //////console.log(error.response);
        });
    },
    reload: function() {
      location.reload();
    },
    sendData: function() {
      if (this.makinaId == 0) {
        var url = store.state.base_url + "AslanSahalar/updateCheck.php?key=123";
        var datas = {
          makinaId: this.tempmachine,
          id: localStorage.getItem("id"),
          token: localStorage.getItem("token"),
          date: this.veriler.date,
          delgiadeti: this.veriler.delgiadeti,
          motorbaslama: this.veriler.motorbaslama,
          motorbitis: this.veriler.motorbitis,
          aciklamaone: this.veriler.aciklamaone,
          aciklamatwo: this.veriler.aciklamatwo,
          giderId: this.giderId,
          personel_id: this.temppersonel,
          yonlendir: this.veriler.yonlendir,
        };
      } else {
        var url = store.state.base_url + "Cek/updateCheck.php?key=123";
        var datas = {
          makinaId: this.makinaId,
          id: localStorage.getItem("id"),
          token: localStorage.getItem("token"),
          date: this.veriler.date,
          delgiadeti: this.veriler.delgiadeti,
          motorbaslama: this.veriler.motorbaslama,
          motorbitis: this.veriler.motorbitis,
          aciklamaone: this.veriler.aciklamaone,
          aciklamatwo: this.veriler.aciklamatwo,
          giderId: this.giderId,
          personel_id: this.temppersonel,
          yonlendir: this.veriler.yonlendir,
        };
      }

      axios
        .post(url, JSON.stringify(datas))
        .then((response) => {
          if (response.data.data == true) {
            this.$swal({
              text: "Güncelleme İşleminiz Başarıyla Gerçekleştirildi!",
              icon: "success",
              closeOnClickOutside: true,
            });
            setTimeout(function() {
              window.location =
                "studentsDetail?idm=" +
                response.data.yonlendir +
                "#/notesPage?idm=" +
                response.data.yonlendir;
            }, 1250);
          } else {
            this.$swal({
              text: "Hata Oluştu Admine Danışın!",
              icon: "error",
              closeOnClickOutside: false,
            });
          }
        })
        .catch((error) => {
          //conso.log(error.response);
        });
    },
  },

  components: {
    Header,
    Sidebar,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/UpdateCheck.vue